const SDKComponents = {
  state: {
    HeaderText: '个人中心',
    AndroidData: '' // 保存安卓传递多来的值
  },
  mutations: {
    SET_HEADER_TEXT: (state, text) => {
      state.HeaderText = text
    },
    SET_ANDROID_DATA: (state, data) => {
      state.AndroidData = data
    }
  },
  actions: {
    SET_SDK_HEADER_TEXT ({commit}, text) {
      commit('SET_HEADER_TEXT', text)
    },
    SET_SDK_ANDROID_DATA ({commit}, data) {
      commit('SET_ANDROID_DATA', data)
    }
  }
}

export default SDKComponents



// WEBPACK FOOTER //
// ./src/store/modules/sdkComponents.js